import React from "react";

const Input = ({ type, name, label, value, error, onChange }) => {
  return (
    <div>
      <label className="formLabel" htmlFor={name}>
        {label}
      </label>
      <input
        className="form-control2"
        value={value}
        onChange={onChange}
        name={name}
        id={name}
        type={type}
      />
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Input;
//className="form-group"
